import { IDataOptions } from '@/interfaces/IDataOptions';
import { IPaginated } from '@/interfaces/IPaginated';
import { ICustomer } from '@/interfaces/ICustomer';
import { Globals } from '@/modules/Globals';
import axios from 'axios';

const apiUrl = Globals.apiPath + '/customers';

export interface ICreateCustomerDto {
  restaurantId: number;
  name: string;
  customId?: string;
  taxIdType?: string;
  taxId?: string;
  address?: string;
  address2?: string;
  addressComment?: string;
  lat?: number;
  lng?: number;
  tel?: string;
  email?: string;
}

export interface IUpdateCustomerDto {
  name?: string;
  customId?: string;
  taxIdType?: string;
  taxId?: string;
  address?: string;
  address2?: string;
  addressComment?: string;
  lat?: number;
  lng?: number;
  tel?: string;
  email?: string;
}

export enum BalanceAdjustmentType {
  Add = 'add',
  Subtract = 'subtract',
  Set = 'set',
}

export class CustomersService {
  /**
   * Get all customers for a restaurant with pagination
   */
  static async getAll({
    restaurantId,
    options,
  }: {
    restaurantId: number;
    options?: IDataOptions;
  }) {
    const res = await axios.get<IPaginated<ICustomer>>(
      `${apiUrl}?r=${restaurantId}` +
        (options
          ? `&options=${encodeURIComponent(JSON.stringify(options))}`
          : '')
    );
    return res.data;
  }

  /**
   * Get a single customer by ID
   */
  static async getOne(id: number) {
    const res = await axios.get<ICustomer>(`${apiUrl}/${id}`);
    return res.data;
  }

  /**
   * Create a new customer
   */
  static async create(customer: ICreateCustomerDto) {
    const res = await axios.post<ICustomer>(apiUrl, customer);
    return res.data;
  }

  /**
   * Update an existing customer
   */
  static async update(id: number, customer: IUpdateCustomerDto) {
    const res = await axios.put<ICustomer>(`${apiUrl}/${id}`, customer);
    return res.data;
  }

  /**
   * Delete a customer
   */
  static async delete(id: number) {
    const res = await axios.delete(`${apiUrl}/${id}`);
    return res.data;
  }

  /**
   * Adjust customer balance
   */
  static async adjustBalance(data: {
    id: number;
    amount: number;
    type: BalanceAdjustmentType;
    note?: string;
  }) {
    const res = await axios.post(`${apiUrl}/${data.id}/balance`, data);
    return res.data;
  }
}
